import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/styles'
import GridList from '@material-ui/core/GridList'
import { useDispatch, useSelector } from 'react-redux'
import GridListTile from '@material-ui/core/GridListTile'
import GridListTileBar from '@material-ui/core/GridListTileBar'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardMedia from '@material-ui/core/CardMedia'
import Avatar from '@material-ui/core/Avatar'

import { selectors } from '../selectors/loadMenuDataSelectors'
import { selectNavigation } from '../actions/digitalMenuActions'
import DigitalMenuScreen from './DigitalMenuScreen'

const useStyles = makeStyles((theme) => ({
  avatar: {
    width: '100%', //theme.spacing(20),
    height: theme.spacing(20),
  },
  navigationImage: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    height: 140,
    objectFit: 'cover'
  },
  titleBar: {
    fontFamily: 'abadi-mt-condensed-light, sans-serif',
    fontSize: 20
  },
  titleBarBackground: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  navigationsContainer: {
    marginTop: '8px',
    marginLeft: '8px',
    marginRight: '8px'
  }
}))

const NavigationList = (props) => {
  const navigations = useSelector(selectors.getNavigations)
  const storeCode = useSelector(selectors.getStoreCode)
  const dispatch = useDispatch()
  const classes = useStyles()

  const handleNavigationClick = (navigation) => () => {
    dispatch(selectNavigation(navigation, storeCode))
  }

  return <DigitalMenuScreen {...props}>
    <Grid item xs={12} className={classes.navigationsContainer}>
      <GridList cols={2} cellHeight={140}>
        {navigations.map(navigation =>
          <GridListTile
            key={navigation.id}
            cols={1}
            onClick={handleNavigationClick(navigation)}
          >
            <Card>
              <CardActionArea>
                {!navigation.imgUrl && <Avatar variant="square" className={classes.avatar}>
                  {navigation.title}
                </Avatar>}
                {navigation.imgUrl && <CardMedia
                  className={classes.navigationImage}
                  image={navigation.imgUrl}
                  title={navigation.title}
                />}
              </CardActionArea>
            </Card>
            {navigation.imgUrl && <GridListTileBar
              classes={{ root: classes.titleBarBackground, title: classes.titleBar }}
              title={navigation.title}
            />}
          </GridListTile>
        )}
      </GridList>
    </Grid>
  </DigitalMenuScreen>
}

export default NavigationList
